module.exports = __webpack_public_path__ + "img/product-preview-42.3fcc492.png";